import KitService from "../services/kit/KitService";
import GeneralVariables from "../utils/GeneralVariables";
import store from "../../store";
class GeneralHelper {

    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    }

    static makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    static orderId (id) {
        var result = '';
        result = Number(id) + 1000;
        return result;
    }
    
    static makeIdFromNumber(number, length) {
        function MurmurHash3(string) {
            let i = 0;
            let hash = 1779033703 ^ string.length
            for (i; i < string.length; i++) {
                let bitwise_xor_from_character = hash ^ string.charCodeAt(i);
                hash = Math.imul(bitwise_xor_from_character, 3432918353);
                hash = hash << 13 | hash >>> 19;
            } return function () {
                hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
                hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
                return (hash ^= hash >>> 16) >>> 0;
            }
        }
        
        function SimpleFastCounter32(seed_1, seed_2, seed_3, seed_4) {
            return function(){
              seed_1 >>>= 0; seed_2 >>>= 0; seed_3 >>>= 0; seed_4 >>>= 0;
              let cast32 = (seed_1 + seed_2) | 0;
              seed_1 = seed_2 ^ seed_2 >>> 9;
              seed_2 = seed_3 + (seed_3 << 3) | 0;
              seed_3 = (seed_3 << 21 | seed_3 >>> 11);
              seed_4 = seed_4 + 1 | 0;
              cast32 = cast32 + seed_4 | 0;
              seed_3 = seed_3 + cast32 | 0;
              return (cast32 >>> 0) / 4294967296;
            }
        }


        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        let generate_seed = MurmurHash3("String for the Seed Key"+number);
        let random_number = SimpleFastCounter32(generate_seed(), generate_seed());
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(random_number()*charactersLength));
        }
        return result;
    }

    static buildMessage(severity, detail, title = "", life = 3000) {
        var sev = severity == 1 ? 'success' : severity == 2 ? 'warn' : severity == 3 ? 'error' : 'info' 
        return {
            severity: sev,
            detail: detail,
            title: title,
            life: life
        }
    }

    static formatPice(price) {

        return (Math.round(price * 100) / 100).toLocaleString().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    static calculateNetToSeller(price, margin = 0.2, inspection = 100) {
        if (price <= 125) return 0;
        return price * (1 - margin) - inspection
    }

    static calculateDisplayPrice(netToSeller, margin = 0.2, inspection = 100) {
        return (netToSeller * 1 + inspection) / (1 - margin)
    }

    static async getDisplayPrice(kitId, currencyId,netToSeller)
    {
        let kitService = new KitService()
        let response = await kitService.calculateDisplayPrice(kitId, currencyId,netToSeller)
        return response.data.data
    }

    static async getNetToSeller(kitId, currencyId,price)
    {
        let kitService = new KitService()
        let response = await kitService.calculateNetToSeller(kitId, currencyId,price)
        return response.data.data
    }
    static kitLink(kit)
    {
      let brand = kit.brandName;
       if (brand == 'No-Brand')
       {
        brand = encodeURIComponent(kit.title.replace('/',''))
       }

      return encodeURI(
        GeneralVariables.URL +
          store.getters.locale +
          "/" +
          store.getters.slugs.product_details+
          "/"+
          kit.categoryName +
          "/" +
          brand +
          "/" +
          kit.id
      );
    }

    static async estimateUploadSpeed() {
        const fileUrl = GeneralVariables.BACKEND + 'logo' + "?time=" + (new Date().getTime());
        
        try {
            const response = await fetch(fileUrl);
            const reader = response.body.getReader();
    
            // Wait to start the timer until the first chunk is about to be read
            const startTime = performance.now();
            let totalBytes = 0;
    
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
    
                totalBytes += value.length;
            }
    
            const endTime = performance.now();
            const timeTakenSeconds = (endTime - startTime) / 1000;
    
            const downloadSpeedbps = totalBytes / timeTakenSeconds;
    
            // Estimate the upload speed as 60% of the download speed
            const estimatedUploadSpeedbps = downloadSpeedbps * 0.6;
    
            return estimatedUploadSpeedbps;
        } catch (error) {
            return 0;
        }
    }
    
}



export default GeneralHelper